// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Audience } from './Audience';
import {
    AudienceFromJSON,
    AudienceFromJSONTyped,
    AudienceToJSON,
    AudienceToJSONTyped,
} from './Audience';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
    LinksToJSONTyped,
} from './Links';
import type { PublicationWindow } from './PublicationWindow';
import {
    PublicationWindowFromJSON,
    PublicationWindowFromJSONTyped,
    PublicationWindowToJSON,
    PublicationWindowToJSONTyped,
} from './PublicationWindow';

/**
 * A public transportation situation broadcast message affecting the planned PT operation (source HIM, aki Siri::PtSituation).<br>Situations might be caused by a disruption (like an incident, construction site, deviation etc) and typically relate to some area (geofence) and passing `ServiceProduct` resp. concrete `ServiceJourney's`.
 * @export
 * @interface PTSituationMessage
 */
export interface PTSituationMessage {
    /**
     * Identity of message (aka HIM ID).
     * @type {string}
     * @memberof PTSituationMessage
     */
    id: string;
    /**
     * Alternate identity of message (aka HIM externalID). This may contain values set by 'Via' service and therefore relate to RCS-ALEA ID useful for Liveticker, if given.
     * @type {string}
     * @memberof PTSituationMessage
     */
    alternateId?: string;
    /**
     * Priority rank (the smaller the higher): low = 80, medium = 60, high = 40, de:Grossereignis = 20
     * @type {number}
     * @memberof PTSituationMessage
     */
    priority: number;
    /**
     * Heading of message formatted according to SBB business rule (aka HIM head)
     * @type {string}
     * @memberof PTSituationMessage
     */
    title: string;
    /**
     * Complete Footer/text of message formatted according to SBB business rule (HTML tags like BR(eak) are possible). Scoped for browser based UIs (aka HIM text).
     * @type {string}
     * @memberof PTSituationMessage
     */
    detail: string;
    /**
     * Abbreviated Footer/text of message formatted according to SBB business rule (HTML tags like BR(eak) are possible). Scoped for App UIs.
     * @type {string}
     * @memberof PTSituationMessage
     */
    detailShort: string;
    /**
     * 
     * @type {PublicationWindow}
     * @memberof PTSituationMessage
     */
    distributionPeriod?: PublicationWindow;
    /**
     * 
     * @type {Array<Audience>}
     * @memberof PTSituationMessage
     */
    audiences: Array<Audience>;
    /**
     * 
     * @type {Links}
     * @memberof PTSituationMessage
     */
    links?: Links;
}

/**
 * Check if a given object implements the PTSituationMessage interface.
 */
export function instanceOfPTSituationMessage(value: object): value is PTSituationMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('detail' in value) || value['detail'] === undefined) return false;
    if (!('detailShort' in value) || value['detailShort'] === undefined) return false;
    if (!('audiences' in value) || value['audiences'] === undefined) return false;
    return true;
}

export function PTSituationMessageFromJSON(json: any): PTSituationMessage {
    return PTSituationMessageFromJSONTyped(json, false);
}

export function PTSituationMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PTSituationMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'alternateId': json['alternateId'] == null ? undefined : json['alternateId'],
        'priority': json['priority'],
        'title': json['title'],
        'detail': json['detail'],
        'detailShort': json['detailShort'],
        'distributionPeriod': json['distributionPeriod'] == null ? undefined : PublicationWindowFromJSON(json['distributionPeriod']),
        'audiences': ((json['audiences'] as Array<any>).map(AudienceFromJSON)),
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
    };
}

  export function PTSituationMessageToJSON(json: any): PTSituationMessage {
      return PTSituationMessageToJSONTyped(json, false);
  }

  export function PTSituationMessageToJSONTyped(value?: PTSituationMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'alternateId': value['alternateId'],
        'priority': value['priority'],
        'title': value['title'],
        'detail': value['detail'],
        'detailShort': value['detailShort'],
        'distributionPeriod': PublicationWindowToJSON(value['distributionPeriod']),
        'audiences': ((value['audiences'] as Array<any>).map(AudienceToJSON)),
        'links': LinksToJSON(value['links']),
    };
}

